(() => {
  const selector = '.rc-ship-panel[data-rc-quickcart-shipping]';
  const update = (panel) => {
    const english = document.documentElement.lang.toLowerCase().split('-')[0] === 'en';
    const labels = english
      ? { home: 'Home delivery', easybox: 'Locker delivery' }
      : { home: 'Curier Sameday', easybox: 'Easybox' };
    Object.entries(labels).forEach(([option, text]) => {
      const label = panel.querySelector(`[data-rc-option="${option}"] .rc-ship-panel__label`);
      if (label && label.textContent !== text) label.textContent = text;
    });
  };
  const scan = (node) => {
    if (node.nodeType !== 1) return;
    const panel = node.closest(selector);
    if (panel) update(panel);
    node.querySelectorAll(selector).forEach(update);
  };
  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      const panel = target?.closest(selector);
      if (panel) update(panel);
      record.addedNodes.forEach(scan);
    });
  });
  let observedRoot;
  const bind = () => {
    const root = document.getElementById('x-cart-drawer-container');
    if (root === observedRoot) return;
    observer.disconnect();
    observedRoot = root;
    if (!root) return;
    scan(root);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
